<p-dialog
  [header]="header"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '40vw' }"
  [modal]="true"
  [closable]="false"
  [(visible)]="showDialog"
  (visibleChange)="showDialogChange.emit($event)"
>
  <button
    type="button"
    aria-label="Close dialog"
    class="custom-close-button"
    (click)="showDialogChange.emit(false)"
  >
    <span class="pi pi-times"></span>
  </button>

  <ng-content></ng-content>

  <ng-template #footer>
    <p-button
      *ngIf="rejectLabel.length > 0"
      [label]="rejectLabel"
      [outlined]="true"
      severity="secondary"
      (click)="reject()"
    />
    <p-button *ngIf="saveLabel.length > 0" [label]="saveLabel" [outlined]="true" severity="secondary" (click)="save()" />

    <p-button
      *ngIf="acceptLabel.length > 0"
      [label]="acceptLabel"
      class="ms-2"
      (click)="accept()"
    />
  </ng-template>
</p-dialog>
